import styled from 'styled-components';
import { key } from 'styled-theme';
import { media } from '@sizeid/commons/utils/styles';

export default styled.div`
  background: ${key('colors.SIDB.light.50')};
  border-radius: ${key('sizes.borderRadius')};
  padding: 50px 70px;

  h3:first-child {
    margin-top: 0;
  }

  ${media.lessThan('sm')`
    padding: 24px;
  `};
`;
